import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface promotions {
  push: any;
  data: any;
  isSuccess: any;
  title: any;
}

interface promotionsState {
  data: promotions[];
  loading: boolean;
  error: string | null;
}
interface ApiResponse<T> {
  data: T;
  isSuccess: boolean;
  status: number;
}
const PORT = import.meta.env.VITE_USERS_PORT;
const MASTERURL = import.meta.env.VITE_API_USERS_URL;

export const fetchpromotions = createAsyncThunk<promotions[], void, { rejectValue: string }>(
  'promotions/fetchpromotions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.get<{ data: promotions[] }>(
        '/get_all_area_based_ad_promotion',
        PORT,
        MASTERURL,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  },
);
export const createpromotion = createAsyncThunk<promotions, any, { rejectValue: string }>(
  'promotions/createpromotion',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.post<any>(
        '/create_area_based_ad_promotion',
        params,
        PORT,
        MASTERURL,
      );

      if (!response.isSuccess) {
        return rejectWithValue('Failed to create promotion');
      }

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'An error occurred');
    }
  },
);
export const updatepromotion = createAsyncThunk<promotions, any, { rejectValue: string }>(
  'promotions/updatepromotion',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.put<{ data: promotions }>(
        '/update_area_based_ad_promotion',
        params,
        PORT,
        MASTERURL,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  },
);
export const softDeletePromotions = createAsyncThunk<
  { id: number }, // return type
  number, // argument type
  { rejectValue: string } // reject type
>('promotions/softDeletePromotions', async (id, { rejectWithValue }) => {
  try {
    const response = await apiService.patch<{ data: { id: number } }>(
      `/soft_delete_area_based_ad_promotion?id=${id}`,
      {},
      PORT,
      MASTERURL,
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'An error occurred while deleting Promotions',
    );
  }
});

export const promotionsSlice = createSlice({
  name: 'promotions',
  initialState: {
    data: [],
    loading: false,
    error: null,
  } as promotionsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchpromotions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchpromotions.fulfilled, (state, action: PayloadAction<promotions[]>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchpromotions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      })
      .addCase(createpromotion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createpromotion.fulfilled, (state, action) => {
        const messages = action.payload.push?.messages;
      })
      .addCase(createpromotion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      })
      .addCase(updatepromotion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatepromotion.fulfilled, (state, action: PayloadAction<promotions>) => {
        state.loading = false;
        state.data.push(action.payload);
      })
      .addCase(updatepromotion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      });
  },
});

export default promotionsSlice.reducer;
